import { render } from "./AddButton.vue?vue&type=template&id=e10627f2&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=e10627f2&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10627f2"],['__file',"src/components/CampoForm/components/AddButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e10627f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e10627f2', __exports__)) {
    console.log('reload')
    api.reload('e10627f2', __exports__)
  }
  
  module.hot.accept("./AddButton.vue?vue&type=template&id=e10627f2&scoped=true", () => {
    console.log('re-render')
    api.rerender('e10627f2', render)
  })

}


export default __exports__